var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _rect4, _rect5, _rect6, _path15, _path16, _path17, _rect7, _rect8, _rect9, _g, _g2, _rect10, _g3, _g4, _path18, _path19, _path20, _line, _path21, _path22, _path23, _path24, _line2, _path25, _path26, _path27, _path28, _path29, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path30, _line3, _line4, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g5, _path47, _g6, _path48, _path49, _g7, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g8, _path59, _path60, _g9, _path61, _path62, _g10, _g11, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path73, _path74;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup264(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_264",
    "data-name": "Group 264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 514.315,
    height: 391.628,
    viewBox: "0 0 514.315 391.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 514.315,
    height: 391.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 154.8)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 25.967,
    height: 0.881,
    transform: "translate(340.948 157.434)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 164.621)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 167.255)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 41.066,
    height: 31.819,
    transform: "translate(434.914 279.156)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1.041,
    height: 1.041,
    transform: "translate(460.407 240.134)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 4.685,
    height: 5.712,
    transform: "translate(462.747 194.007)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 9.443,
    height: 27.263,
    transform: "translate(464.343 203.908)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 9.578,
    height: 23.808,
    transform: "translate(447.103 203.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 8.667,
    height: 6.016,
    transform: "translate(453.139 202.405)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 8.473,
    height: 7.82,
    transform: "translate(463.92 201.871)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 514.315,
    height: 2.514,
    transform: "translate(0 389.114)",
    fill: "#e4e8ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M310.191,330.129c4.45-2.6,9.822-3.2,14.947-2.628,2.753.306,5.641.972,7.608,2.923s2.509,5.54.471,7.415a7.135,7.135,0,0,1-4.623,1.438c-3.979.165-8.429-.3-11.479,2.261-1.74,1.461-2.826,3.8-4.957,4.582a5.132,5.132,0,0,1-5.771-2.209,8.766,8.766,0,0,1-.981-6.428,9.88,9.88,0,0,1,4.785-7.354",
    fill: "#b0e03a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M299.138,319.978c3.01,3.847,8.378,2.235,10.77-.338s3.27-6.165,4.06-9.588c1.808-7.821,3.613-16.021,1.548-23.777a13.148,13.148,0,0,0-3.36-6.263,6.868,6.868,0,0,0-6.613-1.818c-2.7.871-4.265,3.647-5.361,6.267a56.406,56.406,0,0,0-4.281,24.467c.194,3.894.87,7.952,3.237,11.05",
    fill: "#b0e03a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M291.759,326.12c2.846-3.767,3.143-9.057,1.551-13.5s-4.85-8.126-8.536-11.076a42.728,42.728,0,0,0-14.638-7.619,15.138,15.138,0,0,0-6.44-.745,6.708,6.708,0,0,0-5.184,3.525c-1.342,2.928.273,6.307,1.972,9.044a108.324,108.324,0,0,0,10.076,13.7c2.986,3.454,6.375,6.837,10.72,8.238s8.757.975,10.857-2.1",
    fill: "#b0e03a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M301.647,370.741a8.712,8.712,0,0,0,.157-1.829c.058-1.329.131-3,.218-4.982a71.6,71.6,0,0,1,.729-7.328,56.092,56.092,0,0,1,2.186-8.72,31.663,31.663,0,0,1,3.968-7.995,16.38,16.38,0,0,1,5.294-4.9,15.547,15.547,0,0,1,4.587-1.7,8.785,8.785,0,0,0,1.794-.357,8.485,8.485,0,0,0-1.842.069,14.148,14.148,0,0,0-4.8,1.524,16.344,16.344,0,0,0-5.6,4.955,30.9,30.9,0,0,0-4.12,8.161,52.444,52.444,0,0,0-2.16,8.859,61.491,61.491,0,0,0-.575,7.412c-.046,2.113-.015,3.82.019,5a8.576,8.576,0,0,0,.136,1.832",
    fill: "#a9c0d3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M302.292,376.439a3.615,3.615,0,0,0,0-.846c-.035-.633-.08-1.43-.135-2.409-.117-2.09-.276-5.117-.363-8.859-.212-7.483,0-15.561.643-26.966.611-10.725,1.531-23.218,2.769-31.375.26-1.853.532-3.524.794-4.988.246-1.466.456-2.73.668-3.755.179-.964.324-1.749.439-2.372a3.608,3.608,0,0,0,.1-.839,3.555,3.555,0,0,0-.251.8c-.151.617-.342,1.393-.576,2.346-.258,1.018-.51,2.277-.8,3.739-.3,1.46-.611,3.129-.9,4.982a273.87,273.87,0,0,0-3.115,29.141c-.641,11.429-1.476,22.9-1.127,30.394.154,3.748-.183,8.08.024,10.167.112.976,1.605-.627,1.677,0a3.546,3.546,0,0,0,.147.832",
    fill: "#a9c0d3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M301.281,356.481a32.87,32.87,0,0,0,.019-4.659,41.1,41.1,0,0,0-.832-5.458c-.634-2.831-1.962-5.365-3.218-9a81.366,81.366,0,0,0-4.779-11.535,62.715,62.715,0,0,0-13.211-18.35,31.064,31.064,0,0,0-3.013-2.516c-.46-.348-.869-.7-1.281-.972l-1.154-.709a16.23,16.23,0,0,0-2.191-1.244c-.112.17,3.109,1.842,7.275,5.828a66.077,66.077,0,0,1,12.9,18.3,93.206,93.206,0,0,1,4.8,11.426,101.159,101.159,0,0,1,2.883,9.711c.67,2.808,1.094,5.106,1.361,6.7a16.331,16.331,0,0,0,.441,2.477",
    fill: "#a9c0d3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M287.852,370.673l1.389,19.036H313.7l1.389-19.036Z",
    fill: "#a9c0d3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 32.513,
    height: 7.503,
    transform: "translate(285.212 363.17)",
    fill: "#e8eff5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M195.092,62.619V15.885A15.385,15.385,0,0,1,210.477.5H320.012A15.386,15.386,0,0,1,335.4,15.885V149.269",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M348.883,65.887A13.486,13.486,0,1,1,335.4,52.4a13.486,13.486,0,0,1,13.486,13.486",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M348.883,65.887A13.486,13.486,0,1,1,335.4,52.4,13.486,13.486,0,0,1,348.883,65.887Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M336.766,75.224H334.03c-.155-.663-.317-1.325-.461-1.99a.362.362,0,0,0-.276-.3c-.462-.17-.92-.357-1.367-.566a.4.4,0,0,0-.455.03c-.477.32-.97.615-1.447.934a.291.291,0,0,1-.436-.046q-.8-.822-1.609-1.626a.238.238,0,0,1-.033-.357c.325-.5.633-1,.958-1.5a.388.388,0,0,0,.024-.432c-.215-.465-.392-.948-.605-1.415a.478.478,0,0,0-.27-.246c-.574-.147-1.154-.276-1.735-.392a.271.271,0,0,1-.255-.321c.008-.753.01-1.506,0-2.259,0-.216.083-.295.279-.335.582-.12,1.163-.245,1.738-.39a.482.482,0,0,0,.271-.247q.318-.7.591-1.42a.434.434,0,0,0-.014-.336q-.459-.764-.957-1.5a.3.3,0,0,1,.057-.45c.532-.518,1.053-1.048,1.568-1.583a.284.284,0,0,1,.432-.042c.486.323.989.621,1.476.943a.4.4,0,0,0,.453.026,11.954,11.954,0,0,1,1.286-.525.416.416,0,0,0,.32-.359c.109-.563.241-1.121.356-1.683.036-.175.1-.289.3-.287q1.173.01,2.347,0c.176,0,.229.075.262.241.117.581.27,1.156.379,1.739.04.215.152.28.334.347.444.163.883.343,1.313.54a.354.354,0,0,0,.4-.016c.5-.333,1.019-.649,1.525-.977a.256.256,0,0,1,.384.031c.541.552,1.092,1.094,1.645,1.633a.243.243,0,0,1,.036.376c-.344.509-.656,1.038-.992,1.551a.328.328,0,0,0-.016.373c.215.465.392.948.6,1.415a.484.484,0,0,0,.274.243c.669.17,1.343.318,2.016.473v2.736c-.661.16-1.321.325-1.984.475a.413.413,0,0,0-.337.305c-.168.463-.381.909-.557,1.369a.441.441,0,0,0,.012.337c.3.51.617,1.014.945,1.507a.319.319,0,0,1-.059.481q-.789.765-1.552,1.554a.309.309,0,0,1-.461.046c-.479-.316-.972-.609-1.45-.925a.4.4,0,0,0-.455-.027,12.057,12.057,0,0,1-1.283.53.426.426,0,0,0-.32.361c-.145.655-.31,1.305-.466,1.957m-5.718-9.342a4.342,4.342,0,1,0,8.683,0,4.342,4.342,0,0,0-8.683,0",
    fill: "#a9c0d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M413.127,250.987H275.953a4.935,4.935,0,0,1-4.935-4.936V124.2a4.935,4.935,0,0,1,4.935-4.936H413.127a4.936,4.936,0,0,1,4.936,4.936V246.051a4.936,4.936,0,0,1-4.936,4.936",
    fill: "#e8eff5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M370.26,181.56H289.425a3.689,3.689,0,0,1-3.689-3.688v-31.1a3.689,3.689,0,0,1,3.689-3.689H370.26a3.689,3.689,0,0,1,3.688,3.689v31.1a3.688,3.688,0,0,1-3.688,3.688",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    d: "M3.688,0H84.524a3.688,3.688,0,0,1,3.688,3.688v31.1a3.689,3.689,0,0,1-3.689,3.689H3.688A3.688,3.688,0,0,1,0,34.788V3.688A3.688,3.688,0,0,1,3.688,0Z",
    transform: "translate(285.736 143.084)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 0.628
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 3.227,
    height: 4.391,
    transform: "translate(299.222 172.021)",
    fill: "#c4ff20"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 3.227,
    height: 8.357,
    transform: "translate(305.844 168.055)",
    fill: "#c4ff20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 3.227,
    height: 13.228,
    transform: "translate(312.466 163.184)",
    fill: "#c4ff20"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 2.936,
    height: 19.643,
    transform: "translate(319.234 156.769)",
    fill: "#c4ff20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M323.775,176.412H296.261v-25.15",
    fill: "none",
    stroke: "#c4ff20",
    strokeWidth: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M299.221,167.759s10.092-.29,18.614-15.646",
    fill: "none",
    stroke: "#a9c0d3",
    strokeWidth: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M318.67,149.577l-3.336,2.134a.424.424,0,0,0,.034.734l3.515,1.822a.425.425,0,0,0,.62-.4l-.18-3.956a.425.425,0,0,0-.653-.338",
    fill: "#a9c0d3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 7.795,
    height: 1.005,
    transform: "translate(299.741 152.449)",
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 3.552,
    height: 1.005,
    transform: "translate(299.741 154.506)",
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 4.542,
    height: 5.139,
    transform: "translate(334.784 154.199)",
    fill: "#ebeaef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 154.8)",
    fill: "#ebeaef"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 157.433)",
    fill: "#ebeaef"
  }))))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 4.542,
    height: 5.139,
    transform: "translate(334.784 164.021)",
    fill: "#ebeaef"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 164.621)",
    fill: "#ebeaef"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 25.967,
    height: 0.882,
    transform: "translate(340.948 167.255)",
    fill: "#ebeaef"
  }))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M384.859,126.729A2.862,2.862,0,1,1,382,123.868a2.861,2.861,0,0,1,2.861,2.861",
    fill: "#f4feff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M395.168,126.729a2.861,2.861,0,1,1-2.861-2.861,2.861,2.861,0,0,1,2.861,2.861",
    fill: "#f4feff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M405,126.729a2.861,2.861,0,1,1-2.861-2.861A2.861,2.861,0,0,1,405,126.729",
    fill: "#f4feff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 147.961,
    transform: "translate(270.753 135.831)",
    fill: "none",
    stroke: "#c4ff20",
    strokeWidth: 0.87
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M129.767,177.087V68.43a5.551,5.551,0,0,1,5.551-5.551h139.94a5.551,5.551,0,0,1,5.551,5.551V177.087Z",
    fill: "#9cc3f6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M243.873,73.447a2.862,2.862,0,1,1-2.861-2.861,2.861,2.861,0,0,1,2.861,2.861",
    fill: "#f4feff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M254.182,73.447a2.862,2.862,0,1,1-2.861-2.861,2.861,2.861,0,0,1,2.861,2.861",
    fill: "#f4feff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M264.017,73.447a2.861,2.861,0,1,1-2.861-2.861,2.861,2.861,0,0,1,2.861,2.861",
    fill: "#f4feff"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 150.961,
    transform: "translate(129.767 82.549)",
    fill: "none",
    stroke: "#c4ff20",
    strokeWidth: 0.87
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M268.586,167.083H190.459a2.749,2.749,0,0,1-2.749-2.748V94.561a2.748,2.748,0,0,1,2.749-2.748h78.127a2.748,2.748,0,0,1,2.749,2.748v69.774a2.749,2.749,0,0,1-2.749,2.748",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M175.667,167.083H141.034a2.749,2.749,0,0,1-2.749-2.748V94.561a2.748,2.748,0,0,1,2.749-2.748h34.633a2.748,2.748,0,0,1,2.749,2.748v69.774a2.749,2.749,0,0,1-2.749,2.748",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M197.04,155.571s7.013-3.469,9.3-13.381,7.729-14.471,9.16-7.93,1,11.8,5.009,17.445,9.463-9.437,10.035-13.2,4-7.79,7.861,2.419,8.3,10.29,18.744,14.651Z",
    fill: "#a9c0d3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M202.478,155.571s9.876,1.373,15.6-16.633,4.416.164,6.716,6.873,2.157,6.556,4.734,1.978,4.293.915,8.158,2.289,7.392,2.333,8.537-3.923,3.021-13.115,7.3.61c2.744,8.8,3.628,8.806,3.628,8.806Z",
    fill: "#c4ff20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M262.724,155.595H195.705v-52.73",
    fill: "none",
    stroke: "#c4ff20",
    strokeWidth: 1.037
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 22.291,
    height: 1.824,
    transform: "translate(202.478 109.821)",
    fill: "#cad0d3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 44.865,
    height: 3.359,
    transform: "translate(202.478 102.866)",
    fill: "#c4ff20"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 17.035,
    height: 1.824,
    transform: "translate(202.478 112.968)",
    fill: "#cad0d3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 5.938,
    height: 5.938,
    transform: "translate(144.04 100.264)",
    fill: "#cad0d3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 5.938,
    height: 5.938,
    transform: "translate(144.04 113.884)",
    fill: "#cad0d3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 5.938,
    height: 5.938,
    transform: "translate(144.04 127.678)",
    fill: "#cad0d3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 17.613,
    height: 0.479,
    transform: "translate(153.432 101.688)",
    fill: "#cad0d3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 10.581,
    height: 0.479,
    transform: "translate(153.432 103.763)",
    fill: "#cad0d3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 17.613,
    height: 0.479,
    transform: "translate(153.432 115.875)",
    fill: "#cad0d3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 10.581,
    height: 0.479,
    transform: "translate(153.432 117.95)",
    fill: "#cad0d3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 17.613,
    height: 0.479,
    transform: "translate(153.606 129.37)",
    fill: "#cad0d3"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 10.581,
    height: 0.479,
    transform: "translate(153.606 131.445)",
    fill: "#cad0d3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M167.635,152.125a8.738,8.738,0,1,1-8.739-8.739,8.739,8.739,0,0,1,8.739,8.739",
    fill: "#c4ff20"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 9.717,
    transform: "translate(158.896 147.267)",
    fill: "none",
    stroke: "#004d78",
    strokeWidth: 1.436
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 9.717,
    transform: "translate(154.038 152.125)",
    fill: "none",
    stroke: "#004d78",
    strokeWidth: 1.436
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M105.016,373.486s1.31,8.868,0,13l10.582-1.108s-4.031-5.039-3.225-14.714Z",
    fill: "#ffb4bc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M59.061,372.075s-.3,7.155,1.411,11.69c0,0-7.458,1.31-8.163.4s1.108-5.039,0-12.093Z",
    fill: "#ffb4bc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M105.016,380.037a16.863,16.863,0,0,0,8.768-1.461,13.877,13.877,0,0,0,10.884,5.913c7.659.486,5.844,4.215,5.844,4.215s-9.371,1.512-16.527.806l-9.575.6s-1.611-3.679-.806-5.77,1.412-4.308,1.412-4.308",
    fill: "#292b49"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M51.6,379.13s3.729,2.419,8.868-.554c0,0,3.151,4.389,10.28,5.913,6.047,1.292,3.225,4.416,3.225,4.416s-9.675,1.008-13.5.5l-9.271.141a7.754,7.754,0,0,1-.706-5.2c.706-2.7,1.109-5.215,1.109-5.215",
    fill: "#292b49"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M157.734,154.565l-10.07,10.629-1.934,11.729,3.748,3.386,2.9-3.991a11.516,11.516,0,0,0,5.2-3.627c1.814-2.539,2.782-4.353,1.693-6.409s-4.232-3.99-4.232-3.99l4.494-6.237a1.171,1.171,0,0,0-1.8-1.49",
    fill: "#ffb4bc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M93.962,163.55s3.141,10.706,2.011,17.974c-.639,4.106-3.847,4.056-6.037,3.417l-.536,3.608H79s2.463-4.562,1.368-8.394-5.839-14.871.092-15.784a98.794,98.794,0,0,1,13.5-.821",
    fill: "#ffb4bc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M93.506,173.974a6.077,6.077,0,0,1,.912-6.387c2.555-3.284,3.832-16.423-11.678-8.576s-9.945,4.288-8.485,12.5,4.927,7.481,5.2,10.857,7.3.365,7.117-1.46.547-3.558,2.19-5.474c0,0-2.19-3.1-.183-5.657s3.011.912,3.1,2.737a1.459,1.459,0,0,0,1.825,1.46",
    fill: "#322e40"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M72.9,192.46s1.88-6.371,7.5-6.5,8.869-1,10.993,6.5c0,0-13.5,1.5-18.494,0",
    fill: "#c1fe24"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M44.885,267.472l7.106-2.344.681,3.78a37.951,37.951,0,0,1,2.267,3.705,9.418,9.418,0,0,1,.908,4.309,15.323,15.323,0,0,0,.029,6.2s-1.147,1.307-2.566-2.321c-1.325-3.392-8.879-2.366-8.879-2.366s-1.285-5.519.908-6.8a36.374,36.374,0,0,1-.454-4.158",
    fill: "#ffb4bc"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M45.49,277.224s-1.663-1.058-1.814,1.814-.53,4.536,1.36,4.461a3.076,3.076,0,0,0,2.646,0s.908,1.056,3.175-.456a3.824,3.824,0,0,0,2.873-.756,8.505,8.505,0,0,1-.529-3.78s-2.192-1.436-2.344-2.873c0,0-1.587.378-1.36,1.664,0,0-1.588-1.286-1.739.226,0,0-2.117-1.663-2.268-.3",
    fill: "#db97a1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M104.108,272.3s7.256,18.14,6.047,39.1,1.209,25.8,3.023,43.939,1.412,20.761,1.412,20.761-10.052.559-14.889.358c0,0-8.942-36-8.136-50.31s-5.8-35.911-8.62-40.749c0,0-6.349,32.174-9.977,39.43S65.107,372.381,64.5,375.92c0,0-9.978,2.18-14.009.276,0,0-.029-32.54,2.1-39.8s8.782-61.09,8.782-61.09,34.063-10.059,42.73-3.005",
    fill: "#00234e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M56.693,269.8s-11.137,2.711-13.153,2.61c0,0,1.21-30.737,1.714-34.264s1.511-8.063,2.015-8.768c.415-.581,7.733-23.169,10.3-31.124a5.217,5.217,0,0,1,3.674-3.451l13.616-3.479a1.278,1.278,0,0,0,.751-.488c.312-.458,1.661-1.272,7.231-1.467,2.968-.1,7.66,2.3,7.66,2.3a46.816,46.816,0,0,1,12.8,2.537c6.349,2.318,22.977-2.894,24.388-4.823s18.272-17.646,18.746-20.523c0,0,8.215,5.9,9.424,8.213,0,0-20.632,27.52-26.88,29.032-5.117,1.237-17.264,5.758-21.789,8.491a3.49,3.49,0,0,0-1.681,2.82c-.225,4.613,1.513,17.68,1.675,19.7.2,2.52,1.055,41.142,1.055,43.259,0,0-21.466,2.922-27.815,2.418a131.942,131.942,0,0,1-20.962-4.132s3.024-20.054,3.729-22.977.806-15.117.5-18.14a97.9,97.9,0,0,1-.283-10.264,45.136,45.136,0,0,0-4.2,10.072c-1.31,5.14-2.519,32.451-2.519,32.451",
    fill: "#4574ab"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M417.673,210.693l-1.233-3.184s.719-2.773-2.773-4.006-3.787-1.361-3.787-1.361-.463.578,2.2,1.733c0,0,.693.925-.038,1.425a2.881,2.881,0,0,1-2.966.232,18.557,18.557,0,0,1-3.2-1.965,2.779,2.779,0,0,0-3.2-.693l3.543,4.006a4.813,4.813,0,0,0,3.043,1.656,14.207,14.207,0,0,1,2.889.5c.539.192,1.668,2.281,2.169,3.745Z",
    fill: "#ffb4bc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M446.762,223.939c-.94.356-2.527,2.087-4.968,3.519-2.8,1.642-14.282,8.3-16.8,8.147-5.209-.326-13.271-21.428-13.271-21.428l4.984-6.113s7.074,12.932,9.888,12.5c2.249-.347,15.039-9.607,19.991-14.325,1.148-1.1,4.518-1.6,4.518-1.6l-2.934,8.461s-1,10.683-1.409,10.838",
    fill: "#b0e03a"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M468.605,246.281s-.383,6.547-3.583,18.015a180.657,180.657,0,0,1-7.29,20.854c-1.6,3.841-3.426,7.909-5.523,12.2q-1.419,2.922-3.019,5.969c-1.228,34.731-20.714,70.041-20.714,70.041-1.079.555-4.849-.055-4.826-1.15,2.886-4.584,8.566-49.085,12.226-70.19.227-2.871.556-5.945.962-9.121,1.072-8.518,2.652-17.788,4.193-25.939,2.417-12.836,4.725-22.9,4.725-22.9l6.422.625Z",
    fill: "#ffb4bc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M476.263,294.357h-.008q-.774,5.6-2,11.984c6.962,23.232-7.353,68.563-7.353,68.563-2.425.477-3.267,1.038-4.355.225,1.026-15.054-.542-50.046-2.638-71.268-.188-1.924-.423-4.044-.681-6.3-.43-3.825-.946-8.049-1.494-12.406-.923-7.3-1.963-14.98-2.9-21.785-1.142-8.229-2.143-15.191-2.652-18.688-.219-1.541-.344-2.409-.344-2.409l20.1,2.175s5.108,5.733,5.883,23.631a146.173,146.173,0,0,1-1.557,26.283",
    fill: "#ffb4bc"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M474.253,306.341l.642,2.467c-6.328,2.073-9.352,1.972-14.366,2.167-.232-2.058-.009-6.6-2.8-8.85-2.4-1.934-7.872-1.566-8.125-3.578-.435,4.352.048,4.787-.913,11.252-5.271-.048-10.471-.028-13.772-1.765,1.072-8.518,2.652-17.133,4.193-25.283A25.108,25.108,0,0,1,445.936,280a30.25,30.25,0,0,1,6.969-.837,52.873,52.873,0,0,1,10.193.931,64.124,64.124,0,0,1,12.8,3.778c.29,6.853-.132,11.685-1.642,22.472"
  }))))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M446.762,241.876l25.32.4.72,3.437s5.862,13.475,6.559,33.39c.3,8.554-2.247,8.255-3.371,28.782,0,0-21.891,1.2-42.108-3.128,0,0,6.6-48.257,11.347-59.6Z",
    fill: "#274065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M461.422,240.817a.52.52,0,1,1-.331-.657.521.521,0,0,1,.331.657",
    fill: "#fff"
  }))))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M471.315,203.592s-15.025,7.185-13.651.448c0,0-5.5-.128-9.148,2.033,0,0-2.275,8.955-.459,33.139l-4.377,9,8.266,4.394,5.17-6.838,3.662,8.162,16.21-4.315-2.971-9.042s1.845-20.671,6.648-30.062c0,0-.648-6.9-9.35-6.919",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M470.561,190.728c-1.084,3.8-2.446,10.76-.005,13.337,0,0,3.417,3.388-6.637,2.943a17,17,0,0,1-4.343,5.88,11.267,11.267,0,0,1-.758-5.783c-6.461-.648-.1-3.2-.1-3.2,4.338-.955,4.507-4.106,4.029-7.073Z",
    fill: "#ffb4bc"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M467.374,194.007l-4.627,3.608a11.774,11.774,0,0,1,.179,2.1c1.644-.212,4.031-1.961,4.354-3.657a5.69,5.69,0,0,0,.094-2.056"
  }))))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M473.787,185.366c-1.13,5.587-1.49,7.97-4.724,10.613-4.864,3.975-11.441,1.745-11.993-3.975-.5-5.149,1.435-13.421,7.233-15.191a7.3,7.3,0,0,1,9.484,8.553",
    fill: "#ffb4bc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M469.026,181.252c3.036,4.032-3.377,8.532,2.977,8.354s3.9-9.18.156-11.27-3.133,2.916-3.133,2.916",
    fill: "#1a2e35"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M457.934,183.019a.26.26,0,0,1-.191-.065.276.276,0,0,1,0-.391,2.93,2.93,0,0,1,2.386-1.023.254.254,0,0,1,.217.309.3.3,0,0,1-.326.242,2.337,2.337,0,0,0-1.88.83.3.3,0,0,1-.2.1",
    fill: "#1a2e35"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M466.9,178.116s1.008,6.619,5.38,7.784.919-6.778.919-6.778,1.592-4.433-4.211-5.639c-16.09-3.343-15.433,7.809-13.654,16.488a9.554,9.554,0,0,1,1.06-5.15c1.345-2.258,2.669-.279,10.506-6.705",
    fill: "#1a2e35"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M471.233,174.746a12.2,12.2,0,0,1,7.537,13.033c-.6,4.551-6.284,9.3-7.2,9.456l-2.509-1.257s4.1-4.345,3.3-6.4-1.639-2.266-1.639-2.266Z",
    fill: "#1a2e35"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M474.256,190.775a3.916,3.916,0,0,1-2.411,2.054c-1.308.327-1.853-1.175-1.4-2.662.409-1.338,1.583-3.121,2.852-2.778,1.251.338,1.631,2.082.957,3.386",
    fill: "#ffb4bc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M482.605,176.445a5.686,5.686,0,1,1-5.686-5.686,5.686,5.686,0,0,1,5.686,5.686",
    fill: "#1a2e35"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M482.137,264.868l-9.2.62s-6.735-21.955-8.043-30.79c-.1-.6-.159-1.136-.193-1.6a21.16,21.16,0,0,1-.027-2.239l0-.008a45.818,45.818,0,0,1,.745-5.981c1.509-8.066,4.993-17.916,8.368-20.962a33.4,33.4,0,0,1,5.379,2.481c.851.55,5.616,4.4,5.616,4.4-.991,1.93-4.8,1.184-5.777,5.358-.891,3.837,2.483,9,1.773,12.906a37.931,37.931,0,0,0,.248,13.114c5.526,10.978,1.112,22.7,1.112,22.7",
    fill: "#b0e03a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M468.774,213.787l1.544,4.106-1.193,2.841-4.4,10.437-.057-.312,0-.008a30.076,30.076,0,0,1-.312-5.69,29.368,29.368,0,0,1,9.424-21.253s-.272,3.552-1.214,11.13Z",
    fill: "#b0e03a"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M468.774,213.787l1.544,4.106-1.193,2.841-4.4,10.437-.057-.312,0-.008a30.076,30.076,0,0,1-.312-5.69,29.368,29.368,0,0,1,9.424-21.253s-.272,3.552-1.214,11.13Z",
    fill: "#9cc129"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M450.791,238.289l-5.243,24.442-7.9-3.242,7.9-21.051a8.673,8.673,0,0,0,.579-4.167,55.214,55.214,0,0,1-.579-5.94,66.852,66.852,0,0,1,2.859-22.859,22.2,22.2,0,0,1,6.23-1.386s.014-.014.022-.011c.4-.028.811-.035,1.219-.034,0,0-3.96,6.576-4.922,22.959-.013.2-.031.416-.038.627-.008.051-.011.085-.011.085-.109,2.167-.175,4.5-.169,7.015q.006,1.722.053,3.562",
    fill: "#b0e03a"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M450.908,227.713l-.13-.709-2.119-11.668,2.037-2.03-3.592,2.006s4.813-10.22,6.769-10.98a6.527,6.527,0,0,1,.765-.245s.013-.014.021-.011a2.874,2.874,0,0,1,2.023-.018c-2.477,1.316-5.137,19.13-5.672,22.942-.045.3-.071.51-.092.628-.007.05-.01.085-.01.085",
    fill: "#b0e03a"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M450.908,227.713l-.13-.709-2.119-11.668,2.037-2.03-3.592,2.006s4.813-10.22,6.769-10.98a6.527,6.527,0,0,1,.765-.245s.013-.014.021-.011a2.874,2.874,0,0,1,2.023-.018c-2.477,1.316-5.137,19.13-5.672,22.942-.045.3-.071.51-.092.628-.007.05-.01.085-.01.085",
    fill: "#9cc129"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M461.806,202.4s-3.351,2.267-2.988,4.7l-5.679,1.315s3.426-5.686,8.667-6.016",
    fill: "#e2e2e2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M471.806,209.691l-7.886-2.683s4.24-3.325,5.572-5.137l2.589,2,.008.008c.057.144.807,2.079-.283,5.81",
    fill: "#e2e2e2"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M461.806,202.4s-3.351,2.267-2.988,4.7l-5.679,1.315s3.426-5.686,8.667-6.016",
    fill: "#e2e2e2"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M471.806,209.691l-7.886-2.683s4.24-3.325,5.572-5.137l2.589,2,.008.008c.057.144.807,2.079-.283,5.81",
    fill: "#e2e2e2"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M426.788,373.855s2.9-2.408,3.995,1.459-.392,3.241-.7,4.416-2.507,5.4-3.29,7.99h-.94l2.037-7.3-6.11,7.3-10.5.549s-1.254-3.643,6.815-3.467Z",
    fill: "#274065"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M462.785,375.319s2.883-1.25,3.469.4,1,2.262.948,4.07.912,6.415-.021,9.7c0,0-.923,1.392-6.574.027,0,0,.074-5.627.963-8.305,0,0,.222-4.525,1.215-5.891",
    fill: "#274065"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M462.71,371.6l3.92-2.524a40.83,40.83,0,0,0,.27,5.825,13.68,13.68,0,0,1-.96,8.29c-1.573,3.366-3.285,3.167-3.813-.442a14.687,14.687,0,0,1-.105-5.217s.667-1.216.688-5.932",
    fill: "#ffb4bc"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M425.568,366.083s3.593-1.1,5.238.385c0,0-2.529,4.175-2.373,6.525,0,0-3.055,12.221-11.437,12.221,0,0,5.182-6.639,8.572-19.131",
    fill: "#ffb4bc"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M448.267,297.277l-95.36-72.586a4.5,4.5,0,0,1-.855-6.308l26.288-34.536a4.5,4.5,0,0,1,6.308-.855l95.359,72.586a4.5,4.5,0,0,1,.856,6.308l-26.287,34.536a4.5,4.5,0,0,1-6.309.855",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M448.267,297.277l-95.36-72.586a4.5,4.5,0,0,1-.855-6.308l26.288-34.536a4.5,4.5,0,0,1,6.308-.855l95.359,72.586a4.5,4.5,0,0,1,.856,6.308l-26.287,34.536A4.5,4.5,0,0,1,448.267,297.277Z",
    fill: "none",
    stroke: "#e6e6e6",
    strokeWidth: 0.654
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M397.9,229.346a15.868,15.868,0,1,1-3.015-22.237,15.868,15.868,0,0,1,3.015,22.237",
    fill: "#a9c0d3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M394.89,207.109a15.868,15.868,0,0,0-22.237,3.015l12.626,9.611Z",
    fill: "#c4ff20"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M416.33,219.533a2.206,2.206,0,1,1-.419-3.091,2.206,2.206,0,0,1,.419,3.091",
    fill: "#00234e"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M412.048,216.273l-3.65-2.779-14.392,3.9",
    fill: "none",
    stroke: "gray",
    strokeWidth: 0.316
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 3.36,
    height: 35.396,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 430.448, 246.614)",
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 3.36,
    height: 5.604,
    transform: "translate(422.578 240.623) rotate(-52.721)",
    fill: "#ccc"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 3.36,
    height: 5.604,
    transform: "translate(417.945 246.711) rotate(-52.721)",
    fill: "#ccc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 3.36,
    height: 5.604,
    transform: "translate(413.31 252.799) rotate(-52.721)",
    fill: "#ccc"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 3.361,
    height: 35.472,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 425.814, 252.702)",
    fill: "#ccc"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 3.36,
    height: 35.548,
    transform: "translate(421.18 258.789) rotate(-52.722)",
    fill: "#ccc"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 3.361,
    height: 20.083,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 430.448, 246.614)",
    fill: "#c4ff20"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 3.36,
    height: 27.847,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 425.814, 252.702)",
    fill: "#c4ff20"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 3.36,
    height: 32.048,
    transform: "matrix(0.606, -0.796, 0.796, 0.606, 421.18, 258.789)",
    fill: "#c4ff20"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M478.544,259.185l4.433,4.477-2.312,3.192s-2.381,4.451-3.973,5.94-5.08,4.156-6.056,3.591,1.46-3.3,1.7-3.768c.8-1.552,1.033-3.263-.089-2.039a1.217,1.217,0,0,1-1.152.354s-.467-.738.354-1.862,1.767-3.3,3.614-3.376c1.181-.051,3.479-6.509,3.479-6.509",
    fill: "#ffb4bc"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M475.99,263.768s6.566,3.488,8.26,2.82c0,0,5.711-17.517,8.125-26.454a8.958,8.958,0,0,0,0-3.389c-.25-1.956-1.608-11.914-2.115-15.619a11.332,11.332,0,0,0-.872-3.066c-1.249-2.819-4.151-8.329-8.228-9.639,0,0-4.475,13.716-4.168,17.517,0,0,3.457,9,4.434,12.013s-1.841,8.946-2.869,14.39-2.567,11.427-2.567,11.427",
    fill: "#b0e03a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup264);
export default __webpack_public_path__ + "static/media/Group 264.59a1c7b0de81749608095a64b5195aa7.svg";
export { ForwardRef as ReactComponent };